<template>
  <div>
    <CModal
      centered
      :show.sync="showModal"
      :title="file_type.id_file_type ? $t('New file type') : `${$t('File type')} ${file_type.file_name}`"
      :draggable="false"
      :showFooter="false"
    >
      <CRow class="mt-2">
        <CCol col="1"/>
        <CCol col="10">
          <label>{{ $t('File Type EN') }}</label>
          <CInput v-model="file_type.file_type_en"/>
        </CCol>
        <CCol col="1"/>
      </CRow>
      <CRow class="mt-2">
        <CCol col="1"/>
        <CCol col="10">
          <label>{{ $t('File Type FR') }}</label>
          <CInput v-model="file_type.file_type_fr"/>
        </CCol>
        <CCol col="1"/>
      </CRow>
      <CRow class="mt-2">
        <CCol col="1"/>
        <CCol col="10">
          <label>{{ $t('File') }}</label>
          <CRow>
            <FileDragdrop
              class="ml-3"
              @upload="(uploadFiles) => addToAwaitingUpload(uploadFiles[0])"
            />
            <CInput
              style="width: 84%"
              v-model="file_name"
              :disabled="true"
            />
          </CRow>
        </CCol>
        <CCol col="1"/>
      </CRow>
      <CRow class="mt-3 modal-footer">
        <CButton
          class="mz-button v2-mz-btn mr-2 cancel-button"
          color="primary"
          @click="showModal = false"
        >
          {{ $t('Cancel') }}
        </CButton>
        <CButton
          class="mz-button v2-mz-btn mr-2"
          color="primary"
          @click="submitFileType"
          :disabled="
            !file_type.id_file_type &&
            (file_name === '' || !file_type.file_type_en || file_type.file_type_fr === '')
          "
        >
          {{ $t('Confirm') }}
        </CButton>
      </CRow>
    </CModal>
    <CCard>
      <CCardHeader>
        {{ $t("Files type") }}
        <div class="card-header-actions">
          <CButton
            class="mz-button v2-mz-btn mr-2"
            color="primary"
            @click="
              $downloadFile({
                url: FILE_TYPES_ENDPOINTS.export,
              })
            "
          >
            {{ $t("Export") }}
            <i class="ml-2 mz-icon icon-download-alt color-inherit"/>
          </CButton>
          <CButton
            class="mz-button v2-mz-btn mr-2"
            color="primary"
            @click="showNewFileTypeModal"
          >
            {{ $t("Add") }}
            <i class="ml-2 mz-icon icon-add"/>
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <table-component
          :columns="table_columns"
          :headings="table_headings"
          :url="FILE_TYPES_ENDPOINTS.file_types_list"
          :filter-exclude-columns="['actions']"
          ref="table"
        >
          <template #[type]="{ row }" v-for="type in ['file_type_en', 'file_type_fr']">
            <CLink @click="() => showEditFileTypeModal(row)">
              {{ row[type] }}
            </CLink>
          </template>
          <template slot="actions" slot-scope="{ row }">
            <CButton
              @click="() => deleteFileType(row.id_file_type)"
              color="danger"
              variant="outline"
            >
              <i class="fa fa-trash-o"/>
            </CButton>
          </template>
        </table-component>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {FILE_TYPES_ENDPOINTS, FileTypesServices} from "@/services/file_types";

export default {
  name: "FilesView",
  data() {
    return {
      FILE_TYPES_ENDPOINTS,
      showModal: false,
      file_type: {},
      file_name: '',
      file_to_upload: undefined
    }
  },
  computed: {
    table_columns() {
      return [
        this.$t('file_type_en'),
        'template_name',
        'date_creation',
        'user_creation',
        'actions'
      ]
    },
    table_headings() {
      return {
        [this.$t('file_type_en')]: this.$t('File Type'),
        template_name: this.$t('File name'),
        date_creation: this.$t('Date'),
        user_creation: this.$t('User'),
        actions: '',
      }
    }
  },
  methods: {
    async submitFileType() {
      if (!this.file_type.id_file_type) {
        await this.$uploadFile({
          fileId: '1',
          file: this.file_to_upload,
          query: {
            'id_file_type': this.file_type.id_file_type || 0,
            'file_type_en': this.file_type.file_type_en,
            'file_type_fr': this.file_type.file_type_fr,
            'template_name': this.file_name,
          },
          url: FILE_TYPES_ENDPOINTS.file_types_list,
        });
      } else if (this.file_to_upload) {
        await this.$uploadFile({
          fileId: '1',
          file: this.file_to_upload,
          query: {
            'file_type_en': this.file_type.file_type_en,
            'file_type_fr': this.file_type.file_type_fr,
            'template_name': this.file_name,
          },
          url: FILE_TYPES_ENDPOINTS.file_type_details(this.file_type.id_file_type),
        });
      } else {
        await FileTypesServices.updateFileType(
          this.file_type.id_file_type,
          {
            'file_type_en': this.file_type.file_type_en,
            'file_type_fr': this.file_type.file_type_fr,
            'template_name': this.file_type.template_name,
          }
        )
      }
      this.showModal = false
      this.$refs.table.$refs.table.getData()
    },
    showNewFileTypeModal() {
      this.file_type = {}
      this.file_name = ''
      this.file_to_upload = undefined
      this.showModal = true
    },
    showEditFileTypeModal(file_type) {
      this.file_type = {...file_type}
      this.file_name = file_type.template_name
      this.file_to_upload = undefined
      this.showModal = true
    },
    async deleteFileType(file_type_id) {
      await FileTypesServices.deleteFileType(file_type_id)
      this.$refs.table.$refs.table.getData()
    },
    async addToAwaitingUpload(file) {
      this.file_name = file.name
      this.file_to_upload = file
    }
  }
}
</script>


<style>
.modal-header {
  color: #fff;
  background-color: #23145f;
  border-color: #23145f;
}

.cancel-button {
  background-color: rgb(187, 188, 209) !important;
  border-color: rgb(187, 188, 209) !important;
}
</style>
